import { useCallback, useEffect, useState } from 'react';
import { useMediaDevices } from 'hooks';
import { videoPriority } from 'const';
import useMediaStreamTrack from './useMediaStreamTrack';
import useVideoContext from './useVideoContext';

export default () => {
  const { room, localTracks, getLocalVideoTrack, getLocalEnvironmentVideoTrack, removeLocalVideoTrack, onError } = useVideoContext();
  const localParticipant = room?.localParticipant;

  const [isEnvironmentMode, setIsEnvironmentMode] = useState(false);
  const [supportsFacingMode, setSupportsFacingMode] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);

  const videoTrack = localTracks.find((track) => !track.name.includes('screen') && track.kind === 'video');
  const mediaStreamTrack = useMediaStreamTrack(videoTrack);
  const { environmentalVideoInputDevices } = useMediaDevices();

  useEffect(() => {
    const currentFacingMode = mediaStreamTrack?.getSettings()?.facingMode;
    if (currentFacingMode && supportsFacingMode === false) setSupportsFacingMode(true);
  }, [mediaStreamTrack, supportsFacingMode]);

  const toggleFacingMode = useCallback(() => {
    if (!isPublishing) {
      if (videoTrack) {
        const localTrackPublication = localParticipant?.unpublishTrack(videoTrack);
        // TODO: remove when SDK implements this event. See: https://issues.corp.twilio.com/browse/JSDK-2592
        localParticipant?.emit('trackUnpublished', localTrackPublication);
        removeLocalVideoTrack();
      }
      setIsPublishing(true);
      (isEnvironmentMode ? getLocalVideoTrack() : getLocalEnvironmentVideoTrack())
        .then((track) => {
          if (track) {
            localParticipant?.publishTrack(track, {
              priority: videoPriority.standard,
            });
          }
        })
        .catch(onError)
        .finally(() => {
          setIsEnvironmentMode((val) => !val);
          setIsPublishing(false);
        });
    }
  }, [isEnvironmentMode, isPublishing, videoTrack, localParticipant, getLocalVideoTrack, getLocalEnvironmentVideoTrack, onError, removeLocalVideoTrack]);

  return {
    flipCameraDisabled: !videoTrack,
    toggleFacingMode,
    flipCameraSupported: supportsFacingMode && environmentalVideoInputDevices.length >= 1,
    isEnvironmentMode,
  };
};
